import { render, staticRenderFns } from "./DataBilling.vue?vue&type=template&id=416d0708"
import script from "./DataBilling.vue?vue&type=script&lang=js"
export * from "./DataBilling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports